export * from './ButtonTop/script.js';
export * from './Feedback/script.js';
export * from './Footer/script.js';
export * from './FormBase/script.js';
export * from './FormFile/script.js';
export * from './Header/script.js';
export * from './Helper/script.js';
export * from './MainBanner/script.js';
export * from './Slider/script.js';
export * from './Space/script.js';
export * from './Team/script.js';
export * from './modals/ModalCollection/script.js';
export * from './modals/ModalFeedback/script.js';
export * from './modals/ModalPhoto/script.js';
export * from './modals/ModalVideo/script.js';
export * from './pages/About/AboutDescription/script.js';
export * from './pages/About/AboutLink/script.js';
export * from './pages/About/AboutMission/script.js';
export * from './pages/About/AboutSng/script.js';
export * from './pages/About/AboutСharact/script.js';
export * from './pages/Add/AddCatalog/script.js';
export * from './pages/Add/AddDescription/script.js';
export * from './pages/ArticleDetail/script.js';
export * from './pages/Articles/ArticlesMain/script.js';
export * from './pages/CaseDetail/CaseDetailDescription/script.js';
export * from './pages/Cases/CasesBase/script.js';
export * from './pages/Cases/CasesDescription/script.js';
export * from './pages/Catalog/CatalogAddition/script.js';
export * from './pages/Catalog/CatalogBanner/script.js';
export * from './pages/Catalog/CatalogCase/script.js';
export * from './pages/Catalog/CatalogCollection/script.js';
export * from './pages/Catalog/CatalogDescription/script.js';
export * from './pages/Catalog/CatalogList/script.js';
export * from './pages/Catalog/CatalogMain/script.js';
export * from './pages/Catalog/CatalogRequest/script.js';
export * from './pages/Catalog/CatalogStages/script.js';
export * from './pages/Catalog/CatalogTable/script.js';
export * from './pages/Catalog/CatalogText/script.js';
export * from './pages/Connect/ConnectContent/script.js';
export * from './pages/Contact/ContactGeo/script.js';
export * from './pages/Contact/ContactMain/script.js';
export * from './pages/Decision/DecisionDescription/script.js';
export * from './pages/EquipmentDetail/script.js';
export * from './pages/Goods/GoodsDescription/script.js';
export * from './pages/Goods/GoodsMain/script.js';
export * from './pages/Goods/GoodsVideo/script.js';
export * from './pages/Helper/HelperArticles/script.js';
export * from './pages/Helper/HelperDocument/script.js';
export * from './pages/Helper/HelperQuestion/script.js';
export * from './pages/Index/IndexAbout/script.js';
export * from './pages/Index/IndexCase/script.js';
export * from './pages/Index/IndexCatalogLink/script.js';
export * from './pages/Index/IndexEquipment/script.js';
export * from './pages/Index/IndexLink/script.js';
export * from './pages/Index/IndexMain/script.js';
export * from './pages/Index/IndexNews/script.js';
export * from './pages/Index/IndexSteps/script.js';
export * from './pages/News/NewsList/script.js';
export * from './pages/NewsDetail/script.js';
export * from './pages/Production/ProductionDescription/script.js';
export * from './pages/Production/ProductionStages/script.js';
export * from './pages/Production/ProductionText/script.js';
